/**
 * Processes text to handle common escape sequences
 * @param text - The text to process
 * @returns Processed text with escape sequences converted
 */
export const processTextContent = (text: string): string => {
  if (!text) return '';
  
  return text
    .replace(/\\n/g, '\n')  // Convert \n to actual newlines
    .replace(/\\t/g, '\t')  // Convert \t to actual tabs
    .replace(/\\"/g, '"')   // Convert \" to actual quotes
    .replace(/\\'/g, "'");  // Convert \' to actual single quotes
};
